import { render, staticRenderFns } from "./CreateItem.vue?vue&type=template&id=64aedaa2&scoped=true"
import script from "./CreateItem.vue?vue&type=script&lang=js"
export * from "./CreateItem.vue?vue&type=script&lang=js"
import style0 from "./CreateItem.vue?vue&type=style&index=0&id=64aedaa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aedaa2",
  null
  
)

export default component.exports